import { render, staticRenderFns } from "./VaultFilterMenu.vue?vue&type=template&id=42411f64&"
import script from "./VaultFilterMenu.vue?vue&type=script&lang=ts&"
export * from "./VaultFilterMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports